import { Title3 } from "@components/Typography";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { BlinkingCursor, useStyles } from "./styles";
import { CodeInputProps } from "./types";

const ALLOWED_CHARACTERS = /[0-9]/;

export const CodeInput = ({ length, onChangeText, onComplete }: CodeInputProps) => {
  const styles = useStyles();

  const inputRef = useRef<HTMLInputElement>(null);
  const completed = useRef(false);

  const [values, setValues] = useState<Array<string>>([]);
  const [code, setCode] = useState("");
  const [isFocused, setIsFocused] = useState(true);

  const focus = () => {
    if (inputRef.current) {
      inputRef.current.focus();
      setIsFocused(true);
    }
  };

  useEffect(() => {
    focus();
  }, []);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newCode = event.target.value;

    if (newCode && !ALLOWED_CHARACTERS.test(newCode)) {
      return;
    }

    onChangeText(newCode);

    const splittedValues = newCode.split("");

    setValues(splittedValues);
    setCode(newCode);

    if (splittedValues.length === length && !completed.current) {
      completed.current = true;
      onComplete?.(newCode);
    }
  };

  const renderCode = () => {
    const inputCounts = new Array(length).fill("");

    return inputCounts.map((_, index) => {
      return (
        <div style={styles.codeInputContainer} key={"codeInput-" + index} onClick={focus}>
          {values[index] === undefined ? (
            <>
              {index === values.length && isFocused ? (
                <BlinkingCursor />
              ) : (
                <p style={styles.text}>{""}</p>
              )}
            </>
          ) : (
            <div style={styles.codeInput}>
              <Title3 style={styles.text}>{values[index]}</Title3>
            </div>
          )}
        </div>
      );
    });
  };

  const renderHiddenInput = () => {
    return (
      <input
        ref={inputRef}
        value={code}
        style={styles.hidden}
        onChange={onChange}
        onBlur={() => setIsFocused(false)}
      />
    );
  };

  return (
    <>
      <div style={styles.container}>{renderCode()}</div>
      {renderHiddenInput()}
    </>
  );
};
